import { Dialog as DrawerPrimitive } from "radix-ui";

export const DrawerClose = DrawerPrimitive.Close;
